import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ProductsService } from 'src/app/services/products.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AlertController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
export class ModalRedeemCouponPage {
    constructor(modalController, authService, toolsService, productsService, configService, analyticsService, alertController) {
        this.modalController = modalController;
        this.authService = authService;
        this.toolsService = toolsService;
        this.productsService = productsService;
        this.configService = configService;
        this.analyticsService = analyticsService;
        this.alertController = alertController;
        this.couponQuestions2 = [];
        this.hasLocalization = false;
        this.hasAlternativeBrands = false;
        this.brands_borndate_needed = ['1'];
        this.hideUseMyDataWords = ['exito', 'olimpica', 'carulla', 'superinter', 'surtimax', 'surtimayorista'];
        this.showUseMyDataCheckbox = true;
        this.profiles = [];
        this.analyticsService.AnalyticsServiceModalView('redeem-coupon');
        this.loadUser();
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.configService.company_info.allow_coupon_users) {
                yield this.loadUser();
                this.useMyData({ checked: true });
            }
            this.showUseMyDataCheckbox = !this.hideUseMyDataWords.some(word => this.product.name.toLowerCase().includes(word));
            this.productsService.getExternalUserInfo()
                .then((data) => {
                console.log('data', data);
                const usersArray = Object.values(data);
                this.profiles = usersArray.map((item, index) => ({
                    id: item.id,
                    name: item.name,
                    email: item.email,
                    document: item.document
                }));
            })
                .catch((error) => {
                console.error('Error user external info', error);
            });
        });
    }
    ionViewDidEnter() {
        this.loadForm();
    }
    //Function to load user data
    loadUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            try {
                this.user = yield this.authService.getPlayerFullData();
            }
            catch (error) {
                this.toolsService.showErrorToast();
                console.error('[modal-redeem-coupon.page] loadUser');
            }
            yield this.toolsService.dismissLoader();
        });
    }
    //Function to load address form 
    loadForm() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.hasLocalization = false;
            this.hasAlternativeBrands = false;
            if (this.product.alternative_brand_ids) {
                console.debug("loadForm", this.product.alternative_brand_ids);
                this.hasLocalization = true;
                this.hasAlternativeBrands = true;
            }
            else {
                this.hasLocalization = yield this.checkCouponLocalization();
            }
            if (this.product.custom_price) {
                this.hasLocalization = false;
            }
            this.couponQuestions1 = [
                { label: 'Nombre', format: 'input', type: 'text', formControl: new FormControl('', [Validators.required]) },
                { label: 'E-mail', format: 'input', type: 'email', formControl: new FormControl('', [Validators.required, Validators.pattern(/.*@.*\..*/)]) },
                { label: 'Documento', format: 'input', type: 'number', formControl: new FormControl('', [Validators.required]) }
            ];
            console.log(this.product.additional_questions);
            const isArray = Array.isArray(this.product.additional_questions);
            if (isArray && (this.product.additional_questions.length > 0)) {
                console.log('TIENE');
                for (let question of this.product.additional_questions) {
                    console.log(question);
                    this.couponQuestions1.push({
                        label: question.label,
                        format: 'input',
                        type: question.type,
                        formControl: new FormControl('', [Validators.required]),
                    });
                    console.log(this.couponQuestions1);
                }
            }
            else {
                console.log('NO TIENE');
            }
            if (this.hasLocalization) {
                let alternativeBrandsOptions = [];
                if (this.hasAlternativeBrands) {
                    for (let brand of this.product.alternative_brand_ids) {
                        alternativeBrandsOptions.push({ name: brand.nombre, value: brand.brand_id });
                    }
                }
                console.debug("loadForm", this.hasAlternativeBrands);
                this.couponQuestions2 = [
                    { label: 'Marca', format: 'select', options: alternativeBrandsOptions, reset_show_when: true, formControl: new FormControl('', [Validators.required]), is_active: this.hasAlternativeBrands },
                ];
                this.couponQuestions2.push({ label: 'Departamento', format: 'select', options_url: '/products/brand_departments/', request_body: this.getRequestBody(), additional_body: this.getAdditionalBody('get_depts'), reset_show_when: true, formControl: new FormControl('', [Validators.required]), show_when: (!this.hasAlternativeBrands || this.couponQuestions2[0].formControl) });
                this.couponQuestions2.push({ label: 'Ciudad', format: 'select', options_url: '/products/brand_cities/', request_body: this.getRequestBody(), additional_body: this.getAdditionalBody('get_cities'), show_when: this.couponQuestions2[1].formControl, reset_show_when: true, formControl: new FormControl('', [Validators.required]) });
                this.couponQuestions2.push({ label: 'Establecimiento', format: 'select', options_url: '/products/brand_sites/', request_body: this.getRequestBody(), additional_body: this.getAdditionalBody('get_sites'), show_when: this.couponQuestions2[2].formControl, formControl: new FormControl('', [Validators.required]) });
                console.debug("loadForm", this.couponQuestions2);
            }
        });
    }
    //Function to insert current user data into form
    useMyData(event) {
        if (event.checked) {
            this.couponQuestions1[0].formControl.setValue(this.user.user.first_name + ' ' + this.user.user.last_name);
            this.couponQuestions1[1].formControl.setValue(this.user.user.email);
            if (this.user.document)
                this.couponQuestions1[2].formControl.setValue(this.user.document);
            if (!this.configService.company_info.allow_coupon_users) {
                this.couponQuestions1[0].formControl.disable();
                this.couponQuestions1[1].formControl.disable();
                this.couponQuestions1[2].formControl.disable();
            }
        }
        else {
            for (let question of this.couponQuestions1)
                question.formControl.setValue('');
        }
    }
    //Function to load body of the request for getting options
    getRequestBody() {
        var body = {
            brand_id: this.product.brand_id
        };
        return body;
    }
    //Function to load additional body
    getAdditionalBody(type) {
        let body = [];
        console.debug("getAdditionalBody", this.product.alternative_brand_ids, this.couponQuestions2);
        if (this.product.alternative_brand_ids) {
            body.push({ name: 'brand_id', formControl: this.couponQuestions2[0].formControl });
        }
        if (type == 'get_cities') {
            body.push({ name: 'dep_id', formControl: this.couponQuestions2[1].formControl });
        }
        else if (type == 'get_sites') {
            body.push({ name: 'dep_id', formControl: this.couponQuestions2[1].formControl });
            body.push({ name: 'city_id', formControl: this.couponQuestions2[2].formControl });
        }
        return body;
    }
    //Function to close modal
    closeModal() {
        this.modalController.dismiss();
    }
    // Function to check if coupon has localization
    checkCouponLocalization() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.productsService.getDepartments(this.product.brand_id);
                return true;
            }
            catch (err) {
                console.debug("[MODAL-REDEEM-COUPON] checkCouponLocalization()", err);
                return false;
            }
        });
    }
    addToShoppingCart() {
        console.debug("addToShoppingCart", this.couponQuestions1, this.couponQuestions2);
        if (this.toolsService.validateQuestions(this.couponQuestions1) && (!this.hasLocalization || this.toolsService.validateQuestions(this.couponQuestions2))) {
            var additional_info = {
                name: this.couponQuestions1[0].formControl.value,
                email: this.couponQuestions1[1].formControl.value,
                document: this.couponQuestions1[2].formControl.value
            };
            const isDifferentFromAllProfiles = this.profiles.every(profile => profile.name !== additional_info.name ||
                profile.email !== additional_info.email ||
                profile.document !== additional_info.document);
            if (isDifferentFromAllProfiles) {
                this.productsService.saveExternalUserInfo(additional_info);
            }
            if (this.product.additional_questions) {
                let i = 3;
                for (let question of this.product.additional_questions) {
                    let label = question.label;
                    additional_info[label] = this.couponQuestions1[i].formControl.value;
                    i++;
                }
            }
            if (this.hasLocalization) {
                if (this.toolsService.validateQuestions(this.couponQuestions2)) {
                    additional_info['site'] = this.toolsService.getSelectedOption(this.couponQuestions2[3]);
                    if (['906', '1066', '1599', '873', '2', '29', '1', '28'].includes(this.product.sku)) {
                        additional_info['cinema_brand_id'] = this.toolsService.getSelectedOption(this.couponQuestions2[0]).value.toString();
                    }
                }
                else
                    this.toolsService.markAsTouched(this.couponQuestions2);
            }
            this.modalController.dismiss(additional_info);
        }
        else {
            this.toolsService.markAsTouched(this.couponQuestions1);
        }
    }
    selectProfile(profile) {
        this.selectedProfile = profile;
        this.couponQuestions1[0].formControl.setValue(profile.name);
        this.couponQuestions1[1].formControl.setValue(profile.email);
        this.couponQuestions1[2].formControl.setValue(profile.document);
    }
    deleteProfile(profile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                message: `¿Estás seguro que deseas eliminar el perfil <strong>${profile.name}</strong>?<br>
  Este perfil tiene la información necesaria para redimir el cupón.`,
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: (blah) => { }
                    }, {
                        text: 'Sí',
                        handler: () => {
                            this.productsService.deleteExternalUserInfo(profile.id);
                            this.toolsService.showSuccessToast('Perfil de cupón eliminado');
                            this.profiles = this.profiles.filter(p => p.id !== profile.id);
                            this.couponQuestions1[0].formControl.setValue("");
                            this.couponQuestions1[1].formControl.setValue("");
                            this.couponQuestions1[2].formControl.setValue("");
                        }
                    }
                ]
            });
            yield alert.present();
        });
    }
}
